export default __webpack_public_path__ + "assets/audios/1c72d254532628132d337a75f7d78564.mp3";